BatchGeoStore.addReducer(
  "CustomExtents",
  { bounds: null },
  {
    /**
     * Takes a bounds action and merges it with the state. This means that you
     * can pass in {foo: 'bar'} the first time then {hello: 'world'} and then
     * you will now get {foo: 'bar', hello: 'world'}.
     */
    SET_EXTENT: function (state, action) {
      var newCustomExtent = Object.assign({}, state.bounds, action.bounds);

      state.bounds = newCustomExtent;

      return state;
    },
    /**
     * Removes the bounds completely and reverts back to null
     */
    DELETE_EXTENT: function (state) {
      return Object.assign({}, state, {
        bounds: null,
      });
    },
  },
);
